import type { TypedUseSelectorHook } from 'react-redux';
import { useDispatch, useSelector, useStore } from 'react-redux';
import type { Action } from 'redux';
import type { PersistPartial } from 'redux-persist/es/persistReducer';
import type { ThunkDispatch } from 'redux-thunk';
import type { UIState } from '../../ui/uiSlice';
import type { RootState as DefaultRootState } from './getReduxStore';

export interface RootState extends DefaultRootState {
  ui: UIState & PersistPartial;
}

export type Dispatch = ThunkDispatch<RootState, void, Action>;

export const useAppDispatch = () => useDispatch<Dispatch>();

export const useAppStore = () => useStore<RootState>();

const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default useAppSelector;
